module.exports = __webpack_public_path__ + "img/mm.d6d7754e.svg";